export const trendingItems = [
  {
    title: 'Best Nike Shoes Spreadsheet 2026',
    description: 'Freshly updated Nike sneaker spreadsheet with QC-reviewed finds and latest batch comparisons',
  },
  {
    title: 'Top Budget Hoodie Spreadsheet',
    description: 'Affordable hoodie spreadsheet list featuring high-quality picks under budget-friendly price points',
  },
  {
    title: 'Luxury Watches Spreadsheet List',
    description: 'Curated luxury-inspired watch spreadsheet with detailed quality ratings and buyer feedback',
  },
  {
    title: 'Most Popular Streetwear Spreadsheet',
    description: 'The most-saved streetwear spreadsheet collection trending across the community right now',
  },
];

export const spreadsheetPreviewCards = [
  {
    title: 'Sneakers Spreadsheet',
    description: 'Comprehensive sneaker spreadsheet with verified QC photos, sizing guides, and batch comparisons for the best picks',
    imageUrl: 'https://readdy.ai/api/search-image?query=Three%20pairs%20of%20different%20colorway%20sneakers%20arranged%20in%20a%20row%20on%20a%20light%20wooden%20floor%20against%20a%20white%20wall%20natural%20light%20from%20large%20window%20high%20end%20sneaker%20collection%20photography%20clean%20editorial%20aesthetic&width=600&height=450&seq=spreadsheet-preview-01-v2&orientation=landscape',
  },
  {
    title: 'Streetwear Spreadsheet',
    description: 'Hand-picked streetwear spreadsheet featuring hoodies, tees, and jackets from top-rated sellers',
    imageUrl: 'https://readdy.ai/api/search-image?query=Urban%20streetwear%20outfit%20flat%20lay%20with%20oversized%20hoodie%20graphic%20tee%20and%20cargo%20pants%20on%20exposed%20concrete%20floor%20industrial%20loft%20background%20moody%20lighting%20editorial%20street%20style%20photography&width=600&height=450&seq=spreadsheet-preview-02-v2&orientation=landscape',
  },
  {
    title: 'Luxury Inspired Spreadsheet',
    description: 'Premium luxury-inspired spreadsheet collection with detailed quality tiers and material breakdowns',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20inspired%20accessories%20flat%20lay%20including%20a%20minimalist%20watch%20leather%20wallet%20and%20silk%20scarf%20on%20dark%20velvet%20background%20dramatic%20side%20lighting%20high%20end%20catalog%20photography%20rich%20contrast&width=600&height=450&seq=spreadsheet-preview-03-v2&orientation=landscape',
  },
  {
    title: 'Budget Finds Spreadsheet',
    description: 'Budget-friendly spreadsheet discoveries that deliver exceptional value without compromising on style',
    imageUrl: 'https://readdy.ai/api/search-image?query=Affordable%20fashion%20items%20colorful%20flat%20lay%20on%20a%20pastel%20yellow%20background%20including%20socks%20beanie%20and%20canvas%20tote%20bag%20bright%20cheerful%20daylight%20playful%20product%20photography%20budget-friendly%20vibe&width=600&height=450&seq=spreadsheet-preview-04-v2&orientation=landscape',
  },
];